import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
// import { queryBuilder } from "../network";
import { setTabIndex } from "./appStatus/appStatusActions";

export const filmsMiddleware: Middleware =
  (api: MiddlewareAPI<Dispatch<AnyAction>, unknown>) =>
  (next: Dispatch<AnyAction>) =>
  (action: AnyAction) => {
    // if (action.type == setTabIndex) {
    //   queryBuilder.setUrlQuery({ tab: action.payload.tabIndex });
    // }

    return next(action);
  };
